const PENDING_NAV_LOG =
  import.meta.env.DEV ||
  localStorage.getItem("pendingNavDebug") === "1";

export const logPendingNav = (message: string, details?: unknown) => {
  if (!PENDING_NAV_LOG) {
    return;
  }

  if (details === undefined) {
    console.info(`[pending-nav] ${message}`);
    return;
  }

  console.info(`[pending-nav] ${message}`, details);
};
